module.exports = __webpack_public_path__ + "320472545417a936d1264916cdab2e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grrwm.jpg
// module id = 239
// module chunks = 1